import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const imagePath = (path) => `/store/assets/images/${path}`;

  return (
    <div className="footer">
      {/* Footer Static Top Area */}
      <div className="footer-static-top">
        <div className="container">
          <div className="footer-shipping pt-60 pb-55 pb-xs-25">
            <div className="row">
              <div className="col-lg-3 col-md-6 col-sm-6 pb-sm-55 pb-xs-55">
                <div className="li-shipping-inner-box">
                  <div className="shipping-icon">
                    <img src={imagePath('shipping-icon/1.png')} alt="Shipping Icon" />
                  </div>
                  <div className="shipping-text">
                    <h2>Free Delivery</h2>
                    <p>And free returns. See checkout for delivery dates.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 pb-sm-55 pb-xs-55">
                <div className="li-shipping-inner-box">
                  <div className="shipping-icon">
                    <img src={imagePath('shipping-icon/2.png')} alt="Shipping Icon" />
                  </div>
                  <div className="shipping-text">
                    <h2>Safe Payment</h2>
                    <p>Pay with the world's most popular and secure payment methods.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 pb-xs-30">
                <div className="li-shipping-inner-box">
                  <div className="shipping-icon">
                    <img src={imagePath('shipping-icon/3.png')} alt="Shipping Icon" />
                  </div>
                  <div className="shipping-text">
                    <h2>Shop with Confidence</h2>
                    <p>Our Buyer Protection covers your purchasefrom click to delivery.</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6 col-sm-6 pb-xs-30">
                <div className="li-shipping-inner-box">
                  <div className="shipping-icon">
                    <img src={imagePath('shipping-icon/4.png')} alt="Shipping Icon" />
                  </div>
                  <div className="shipping-text">
                    <h2>24/7 Help Center</h2>
                    <p>Have a question? Call a Specialist or chat online.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Static Middle Area */}
      <div className="footer-static-middle">
        <div className="container">
          <div className="footer-logo-wrap pt-50 pb-35">
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="footer-logo">
                  <Link to="/">
                    <img src="/images/logo.svg" alt="PakPoints Logo" style={{ height: '50px', width: 'auto', marginBottom: '15px' }} />
                  </Link>
                  <p className="info">
                    Your trusted online marketplace for quality products. Part of PakPoints - Pakistan's premier community platform connecting societies, businesses, and people.
                  </p>
                </div>
                <ul className="des">
                  <li>
                    <span>Address: </span>
                    Pakistan
                  </li>
                  <li>
                    <span>Phone: </span>
                    <a href="tel:+923330490575">+92 333 0490575</a>
                  </li>
                  <li>
                    <span>Email: </span>
                    <a href="mailto:shop@pakpoints.com">shop@pakpoints.com</a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-6">
                <div className="footer-block">
                  <h3 className="footer-block-title">Shop</h3>
                  <ul>
                    <li><Link to="/store/shop">All Products</Link></li>
                    <li><Link to="/store/shop?featured_type=new_arrival">New Arrivals</Link></li>
                    <li><Link to="/store/shop?featured_type=bestseller">Bestsellers</Link></li>
                    <li><Link to="/store/shop?featured_type=sale">On Sale</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-6">
                <div className="footer-block">
                  <h3 className="footer-block-title">Support</h3>
                  <ul>
                    <li><Link to="/store/about-us">About Us</Link></li>
                    <li><Link to="/store/contact">Contact Us</Link></li>
                    <li><Link to="/store/faq">FAQ</Link></li>
                    <li><Link to="/store">Shipping Info</Link></li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="footer-block">
                  <h3 className="footer-block-title">Follow Us</h3>
                  <ul className="social-link">
                    <li className="facebook">
                      <a href="https://www.facebook.com/pakpoints" target="_blank" rel="noopener noreferrer" title="Facebook">
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                    <li className="twitter">
                      <a href="https://twitter.com/pakpoints" target="_blank" rel="noopener noreferrer" title="Twitter">
                        <i className="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li className="instagram">
                      <a href="https://www.instagram.com/pakpoints" target="_blank" rel="noopener noreferrer" title="Instagram">
                        <i className="fa fa-instagram"></i>
                      </a>
                    </li>
                    <li className="linkedin">
                      <a href="https://www.linkedin.com/company/pakpoints" target="_blank" rel="noopener noreferrer" title="LinkedIn">
                        <i className="fa fa-linkedin"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="footer-newsletter">
                  <h4>Sign up to newsletter</h4>
                  <form action="#" method="post" className="footer-subscribe-form">
                    <div className="mc-form subscribe-form form-group">
                      <input id="mc-email" type="email" autoComplete="off" placeholder="Enter your email" />
                      <button className="btn" type="submit">Subscribe</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Static Bottom Area */}
      <div className="footer-static-bottom pt-55 pb-55">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="footer-links">
                <ul>
                  <li><Link to="/store/shop">Shop</Link></li>
                  <li><Link to="/store/about-us">About Us</Link></li>
                  <li><Link to="/store/contact">Contact</Link></li>
                  <li><Link to="/store/faq">FAQ</Link></li>
                  <li><Link to="/store">Shipping Policy</Link></li>
                  <li><Link to="/store">Return Policy</Link></li>
                  <li><Link to="/store">Privacy Policy</Link></li>
                  <li><Link to="/store">Terms of Service</Link></li>
                  <li><Link to="/store/cart">Shopping Cart</Link></li>
                  <li><Link to="/store/wishlist">Wishlist</Link></li>
                  <li><Link to="/store/compare">Compare</Link></li>
                </ul>
              </div>
              <div className="copyright text-center">
                <a href="#">
                  <img src={imagePath('payment/1.png')} alt="Payment Methods" />
                </a>
              </div>
              <div className="copyright text-center pt-25">
                <span>© {new Date().getFullYear()} PakPoints Store. All rights reserved.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;

